/* eslint-disable*/
import React, { useEffect, useState, useCallback, useContext } from "react";
import _ from "lodash";
import ManageCampaignTableHead
    from "./ManageCampaignTableHead/ManageCampaignTableHead";
import { columns } from "./manage-campaign-table-structure";
import styles from "./ManageCampaignTable.module.css";
import Table from "../../General/Table/Table";
import TableFooter, { PAGE_SIZES } from "../../General/Table/TableFooter/TableFooter";
import { mapCampaigns } from "../../../utils/object-mappers/manage-campaign/map-campaigns";
import { useAppSelector } from "../../../redux/store";
import LoadSpinner from "../../General/LoadSpinner/LoadSpinner";
import { Context } from "../../../context";
import { Slide, toast } from "react-toastify";
import { Msg } from "../CreateCampaign/AlertComponent";
import { ErrorMsg } from "../CreateCampaign/AlertComponent";
import { ReactComponent as Success } from "../../../assets/icons/Check-square-Alert.svg";
import { ReactComponent as Error } from "../../../assets/icons/Close-Alert.svg";

const ManageCampaignTable = ({ search }) => {

    let jwt = useAppSelector(state => state.authReducer.jwt);
    const { user, value } = useContext(Context);
    const [role, setRole] = user;
    // const userName = useAppSelector((state) => state.authReducer.userName);
    // const email = useAppSelector((state) => state.authReducer.email);
    const [totalCampaigns, setTotalCampaigns] = useState(0);
    const [campaigns, setCampaigns] = useState([]);
    const [sortBy, setSortBy] = useState();
    const [context, setContext] = value;
    const [filters, setFilters] = useState({});
    const [isLoaded, setIsLoaded] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPageSize, setSelectedPageSize] = useState(PAGE_SIZES[0]);

    useEffect(() => {
        localStorage.setItem("blockNavigation", "false");
        const getCampaignDetails = (async () => {
            let url = new URL(`${process.env.REACT_APP_API_HOSTNAME}v1/campaigns`);
            let callParams = {
                method: "GET",
                headers: {
                    "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${jwt}`
                    // "user-info": JSON.stringify({ userName: userName, userEmail: email })

                }
            };
            if (!_.isEmpty(filters)) {
                //url = new URL(
                //"https://mktpl.dev.telematicsct.com/v1/campaigns/search");
                url = new URL(`${process.env.REACT_APP_API_HOSTNAME}v1/campaigns/search`);

                callParams = {
                    method: "POST",
                    headers: {
                        "x-api-key": `${process.env.REACT_APP_API_KEY}`,
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${jwt}`
                        // "user-info": JSON.stringify({ userName: userName, userEmail: email })

                    },
                    body: JSON.stringify(
                        filters.freeSearch
                            ? { ...filters }
                            : {
                                ...Object.keys(filters)
                                    .map((value) =>
                                        value === "status" ||
                                            value === "channels" ||
                                            value === "brand" ||
                                            value === "createdBy" ||
                                            value === "category" ||
                                            value === "subCategories"
                                            ? ({
                                                [value]: filters[value].map((val) => val.label)
                                            })
                                            : ({ [value]: filters[value] })
                                    )
                                    .reduce(
                                        (previousValue, currentValue) => ({
                                            ...previousValue,
                                            ...currentValue
                                        }),
                                        {}
                                    )
                            }
                    )
                };
            } 
            // else {
                const params = {
                    page: currentPage,
                    pagesize: selectedPageSize,
                    ...(sortBy && { sortBy })
                };
                url.search = new URLSearchParams(params).toString();
            // }

            const serverResponse = await fetch(url.toString(), callParams);
            const serverResponseJson = await serverResponse.json();
            if (serverResponseJson.status === 'failed' || serverResponse.status !== 200) {
                setCampaigns([])
                setIsLoaded(false)
            } else {
                setTotalCampaigns(serverResponseJson.totalCampaigns);
                setCampaigns(mapCampaigns(serverResponseJson.campaigns));
                setIsLoaded(false);

                localStorage.getItem("forceDelete") === "true"
                    ? toast.success(<Msg id="delete" campaignName="" />, {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        autoClose: 3000,
                        icon: <Success />,
                        transition: Slide,
                        closeOnClick: true
                    })
                    : localStorage.getItem("forceDelete") === "false"
                        ? toast.error(<ErrorMsg id="delete" />, {
                            position: toast.POSITION.TOP_CENTER,
                            hideProgressBar: true,
                            autoClose: 3000,
                            icon: <Error />,
                            transition: Slide,
                            closeOnClick: true
                        })
                        : "";

                localStorage.removeItem("forceDelete");

                setContext();
            }
        });
        setTimeout(() => {
            getCampaignDetails()
        }, 3000); 

    }, [selectedPageSize, currentPage, sortBy, filters, context]);

    useEffect(() => {

        if (search) {
            setFilters({
                freeSearch: search
            });
        } else if (!_.isEmpty(filters) && filters.freeSearch) {
            setFilters({});
        }
    }, [search]);

    const goToPage = useCallback((page) => {
        setCurrentPage(page);
    }, []);

    const changePageSizeTo = useCallback((newPageSize) => {
        setCurrentPage(1);
        setSelectedPageSize(newPageSize);
    }, []);

    const onSortChange = useCallback((newSortBy) => {
        setFilters({});
        setSortBy(newSortBy);
    }, []);

    const onFilterChange = useCallback((filters) => {
        setFilters(filters);
    }, []);

    return <div className={styles.ManageCampaignModule}>
        <ManageCampaignTableHead
            onSortChange={onSortChange}
            onFiltersChange={onFilterChange}
            filters={filters}
        />
        {(isLoaded === true) ? <LoadSpinner /> : <Table columns={columns} data={campaigns} />}

        <TableFooter
            changePageSizeTo={changePageSizeTo}
            selectedPageSize={selectedPageSize}
            currentPage={currentPage}
            goToPage={goToPage}
            totalItems={totalCampaigns} />
    </div>;
};

export default ManageCampaignTable;